@if (selectedLiveClassId) { @if (editModeEnabled) {
<div class="pb-2">
  <black-ui-modal>
    <button
      *blackModalTrigger="let toggle = toggle"
      (click)="toggle()"
      class="daisy-btn"
    >
      Add New Folder
    </button>
    <div
      *blackModalContent="let close = close"
      class="reveal-modal"
      (click)="close()"
    >
      <div
        class="reveal-modal-body bg-base-100 text-base-content border border-base-300 rounded-2xl shadow-2xl max-w-lg w-full"
        id="addTopicModel"
        (click)="$event.stopPropagation()"
      >
        <div class="max-w-full mx-auto px-4 py-4">
          <h5 class="font-bold text-lg mb-2">Add New Folder</h5>
          <div class="daisy-divider"></div>
          <form form>
            <div class="flex flex-col gap-3">
              <div>
                <fieldset class="daisy-form-control">
                  <label class="daisy-label">
                    <span class="daisy-label-text">Folder Name</span>
                  </label>
                  <input
                    [formControl]="materialNameControl"
                    type="text"
                    class="daisy-input daisy-input-bordered w-full"
                    required
                  />
                </fieldset>
                @if ( materialNameControl.invalid && (materialNameControl.dirty
                || materialNameControl.touched) ) { @if (
                materialNameControl.hasError('required') ) {
                <p class="text-error text-sm">Folder name is required</p>
                } }
              </div>
              <div>
                <black-session-picker
                  [liveClassId]="selectedLiveClassId"
                  (sessionSelected)="onSessionSelected($event)"
                ></black-session-picker>
                <p class="text-sm text-base-content/60 mt-1">
                  Select a past session this folder belongs to, or choose
                  <strong>All Sessions</strong> to make it available to everyone.
                </p>
              </div>
              <div>
                <a
                  class="daisy-btn daisy-btn-neutral daisy-btn-block"
                  (click)="addStudyMaterial(close)"
                  >Add Folder</a
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </black-ui-modal>
</div>
} @if (studyMaterials.length === 0) {
  <div class="flex flex-col items-center justify-center py-16 px-4">
    <div class="bg-base-200 rounded-full p-6 mb-4">
      <i class="fa-solid fa-folder-open text-4xl text-base-content/40"></i>
    </div>
    <h3 class="text-xl font-semibold text-base-content mb-2">
      No Resources Available
    </h3>
    <p class="text-base-content/60 text-center max-w-md">
      @if (editModeEnabled) {
        Create folders and upload study materials, documents, or links for your students.
      } @else {
        Study materials and resources will appear here once uploaded by your instructor.
      }
    </p>
  </div>
} @else { @for (material of studyMaterials; track material) {
<black-study-material-card
  [editModeEnabled]="editModeEnabled"
  [studyMaterial]="material"
  [subscriptions]="selectedLiveClass?.subscriptions ?? []"
  [liveClassOwnerId]="selectedLiveClass?.user?.toString()"
  [isAuthorized]="isAuthorized"
  (removeStudyMaterial)="deleteStudyMaterial($event)"
></black-study-material-card>
} } } @else {
<p>Component Failed to load!</p>
}
